import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye exactamente el MEGAPACK?',
  a: 'Incluye 6 tomos digitales con todo el sistema para acompañar esta etapa, más 6 bonos prácticos. Si eliges el sistema completo, también accedes a la estructura avanzada de implementación y organización familiar.'
}, {
  q: '¿Es digital o físico?',
  a: 'Es 100% digital. Recibirás acceso inmediato a todo el material en formato PDF de alta calidad, listo para descargar, leer en cualquier dispositivo o imprimir.'
}, {
  q: '¿Sirve para mi país?',
  a: '¡Sí! El material utiliza un lenguaje neutro y aborda situaciones universales de la vejez y la dinámica familiar, siendo aplicable en cualquier país hispanohablante.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso para descargar todo el contenido al instante.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía incondicional. Si sientes que el sistema no aporta claridad a tu situación familiar, nos escribes y te devolvemos el 100% de tu dinero.'
}, {
  q: '¿Cuál es la diferencia entre el pack básico y el sistema completo?',
  a: 'El pack básico te da el conocimiento y las estrategias (los 6 tomos). El Sistema Familia Organizada te da las herramientas prácticas de implementación: protocolos, guías de pasos y estructuras para organizar a toda la familia de forma real.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-100">
      <div className="max-w-xl mx-auto" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-102">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-103">
          {faqs.map((faq, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-104">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-800/50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-105">
                <span className="font-bold text-white text-sm pr-4" data-id="element-106">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-107" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-108" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-109">
                  <div className="pt-3" data-id="element-110">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}